import { render } from "./socialQuestions.vue?vue&type=template&id=234ff402"
import script from "./socialQuestions.vue?vue&type=script&lang=js"
export * from "./socialQuestions.vue?vue&type=script&lang=js"

import "./socialQuestions.vue?vue&type=style&index=0&id=234ff402&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__